import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SweetAlert from '../Shared/Notification';
import { useParams, useNavigate } from 'react-router-dom';
import APIService from '../../Services/APIService';
import { Button } from 'react-bootstrap';
import SearchBox from '../FlowBuilder/Common/SearchBox/index.tsx';
import { Box, Grid, Typography } from '@mui/material';
import CommonTable from '../Shared/Tables/TableV1.tsx';

const List = () => {
  const [searchFilter, setSearchFilter] = useState('');
  const { campaignId, supplierId } = useParams();
  const [currentCampaign, setCurrentCampaign] = useState({});
  const [currentSupplier, setCurrentSupplier] = useState({});
  const [checklist, setChecklist] = useState([]);
  const [campChecklist, setCampChecklist] = useState([]);
  const navigate = useNavigate();

  const getCurrentCampaign = async (id) => {
    let res = await APIService.get(`/v0/ui/website/${id}/campaign-inventories/`);
    if (res.status == 200) setCurrentCampaign(res.data);
  };

  const getCurrentSupplier = async (supplierId) => {
    let res = await APIService.get(
      `/v0/ui/website/supplier-details?supplier_id=${supplierId}&&supplier_type_code=RS`
    );
    // .query({ supplier_id: supplierId, supplier_type_code: 'RS' });
    if (res.status == 200) setCurrentSupplier(res.data);
  };

  const getSupplierChecklists = async (campaignId, supplierId) => {
    let res = await APIService.get(
      `/v0/ui/checklists/${campaignId}/list_supplier_checklists/${supplierId}`
    );
    if (res.status == 200) setChecklist(res.data);
  };

  const getCampaignChecklists = async (campaignId) => {
    let res = await APIService.get(`/v0/ui/checklists/${campaignId}/list_campaign_checklists`);
    if (res.status == 200) {
      let checklists = [];
      res.data &&
        res.data.length > 0 &&
        res.data.forEach((checklist) => {
          if (checklist.checklist_info.checklist_type === 'campaign') checklists.push(checklist);
        });
      setCampChecklist(checklists);
    }
  };

  useEffect(() => {
    getCurrentCampaign(campaignId);
    if (supplierId) {
      getCurrentSupplier(supplierId);
      getSupplierChecklists(campaignId, supplierId);
    } else {
      getCampaignChecklists(campaignId);
    }
  }, []);
  // const { supplier, campaign,  settings } = props;
  let campaignPermission = true;
  let emptyChecklistText = 'No checklists available. Create your first one now!';
  let supplierChecklistFlag = true;
  let headingText = 'Checklists for ',
    checklistCreateUrl,
    showCreateButton = false;

  if (!supplierId) supplierChecklistFlag = false;
  if (supplierChecklistFlag) {
    headingText += 'Supplier ' + (currentSupplier ? currentSupplier?.name : '');
    checklistCreateUrl = `/r/checklist/create/${campaignId}/${supplierId}`;
    if (currentCampaign && currentSupplier) showCreateButton = true;
  } else {
    headingText += 'Business Service ' + (currentCampaign ? currentCampaign?.campaign?.name : '');
    checklistCreateUrl = `/r/checklist/create/${campaignId}`;
    if (currentCampaign) showCreateButton = true;
  }

  const getFilteredList = (list) => {
    if (!Array.isArray(list)) return [];
    return list.filter(
      (item) =>
        item.checklist_info.checklist_name
          .toLowerCase()
          .replace(/[^0-9a-z]/gi, '')
          .indexOf(searchFilter.toLowerCase().replace(/[^0-9a-z]/gi, '')) !== -1
    );
  };

  const onRemove = async () => {
    let campaignId = campaignId;
    let supplierId = supplierId;
    let checklistId = checklist.checklist_info.checklist_id;
    let res = await APIService.put(`/v0/ui/checklists/${checklistId}/delete_checklist`);
    if (res.status == 200) {
      SweetAlert('Checklist deleted successfully', 'success');
      if (supplierId) {
        getSupplierChecklists(campaignId, supplierId);
      } else {
        getCampaignChecklists(campaignId);
      }
    }
  };

  const filteredList = getFilteredList(checklist);

  const renderChecklistRow = (checklist, index) => {
    // let { settings } = props;
    let editPermission = true;
    let disableEditButton = false;
    if (checklist.checklist_info.status === 'frozen') {
      disableEditButton = true;
    }
    return (
      <tr key={checklist.checklist_info.checklist_id}>
        <td className="hidden-xs">{index + 1}</td>
        <td className="checklist-name">{checklist.checklist_info.checklist_name}</td>
        <td>
          <Link
            to={`/r/checklist/fill/${checklist.checklist_info.checklist_id}`}
            className="btn btn--danger"
          >
            Fill Checklist
          </Link>
        </td>
        <td>
          <button
            type="button"
            className="btn btn--danger"
            onClick={onRemove}
            disabled={!editPermission}
          >
            Remove
          </button>
        </td>
        <td>
          {disableEditButton ? (
            <button type="button" className="btn btn--danger" disabled>
              Edit Checklist
            </button>
          ) : (
            <button
              type="button"
              className="btn btn--danger"
              onClick={() => this.onEdit(checklist.checklist_info.checklist_id)}
              disabled={!editPermission}
            >
              Edit Checklist
            </button>
          )}
        </td>
      </tr>
    );
  };

  const columns = [
    {
      accessorKey: 'sno',
      header: 'Index',
      sort: true,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      enableSorting: false,
      // Cell: ({ row }) =>
      //   dateFormate(row.original?.tentative_start_date, 'DD-MM-YYYY'),
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
    },
    {
      accessorKey: 'action',
      enableSorting: false,
    },
  ];

  return (
    <Box sx={{ padding: 0 }}>
      {/* <Box>
        <Typography variant="h4" fontWeight="bold">
          {headingText}
        </Typography>
        <Box sx={{ marginBottom: '10px', width: '20%' }}>
          <SearchBox handleSearch={(e) => {
            setSearchFilter(e.target.value);
          }} value={searchFilter} />

        </Box>
      </Box> */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            {headingText}
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ alignItems: 'center', pt: 2, pb: 2.5 }} className="search-box-style">
        <Grid item xs={12} sm={6} md={2}>
          <SearchBox
            handleSearch={(e) => {
              setSearchFilter(e.target.value);
            }}
            value={searchFilter}
          />
        </Grid>
      </Grid>
      {/* <div className="list__table">
        <table cellPadding="0" cellSpacing="0">
          <thead>
            <tr>
              <th className="hidden-xs">Index</th>
              <th className="checklist-name">Name</th>
              <th>Action</th>
              <th>Action</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredList && filteredList.length && campaignPermission ? (
              filteredList.map(renderChecklistRow)
            ) : (
              <tr>
                <td colSpan="5">{emptyChecklistText}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div> */}
      <CommonTable
        columns={columns}
        data={filteredList}
        muiTableContainerProps={{
          sx: {
            height: 'calc(100vh - 320px)',
            width: '100%',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
          },
        }}
        state={{ isLoading: false }}
      />
      <div className="list__actions">
        <Button type="button" onClick={(e) => navigate(`/r/checklist/campaigns`)}>
          <i className="fa fa-arrow-left" aria-hidden="true" />
          &nbsp; Back
        </Button>{' '}
        {showCreateButton && campaignPermission ? (
          <Link to={checklistCreateUrl}>Create</Link>
        ) : undefined}
      </div>
    </Box>
  );
};
export default List;
